export default __webpack_public_path__ + "static/media/home_banner.4e43654c.png";